import { InjectionToken } from "@angular/core";

export const EPIC_INGEST_USER = new InjectionToken<string>("EPIC_INGEST_USER");
